let currentGalleryIndex = 0;
let slidesPerView = getSlidesPerView();

function getSlidesPerView() {
  return window.innerWidth <= 768 ? 1 : 3;
}

function getMaxIndex() {
  const items = document.querySelectorAll('.gallery-item');
  return Math.max(0, items.length - slidesPerView);
}

function updateGalleryDisplay() {
  const track = document.getElementById('galleryTrack');
  const items = document.querySelectorAll('.gallery-item');
  if (!track || items.length === 0) return;

  // Set each slide width
  const slideWidth = 100 / slidesPerView;
  items.forEach(item => {
    item.style.width = slideWidth + '%';
  });

  // Slide the track
  const offset = currentGalleryIndex * (100 / slidesPerView);
  track.style.transform = `translateX(-${offset}%)`;

  // Update dots
  updateDots();
}

function nextGallery() {
  const max = getMaxIndex();
  currentGalleryIndex = currentGalleryIndex >= max ? 0 : currentGalleryIndex + 1;
  updateGalleryDisplay();
}

function previousGallery() {
  const max = getMaxIndex();
  currentGalleryIndex = currentGalleryIndex <= 0 ? max : currentGalleryIndex - 1;
  updateGalleryDisplay();
}

function buildDots() {
  const dotsContainer = document.getElementById('galleryDots');
  if (!dotsContainer) return;
  const total = getMaxIndex() + 1;
  dotsContainer.innerHTML = '';
  for (let i = 0; i < total; i++) {
    const dot = document.createElement('button');
    dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.addEventListener('click', () => {
      currentGalleryIndex = i;
      updateGalleryDisplay();
    });
    dotsContainer.appendChild(dot);
  }
}

function updateDots() {
  const dots = document.querySelectorAll('.gallery-dot');
  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === currentGalleryIndex);
  });
}

// Rebuild on resize (desktop ↔ mobile)
window.addEventListener('resize', () => {
  const newSPV = getSlidesPerView();
  if (newSPV !== slidesPerView) {
    slidesPerView = newSPV;
    currentGalleryIndex = 0;
    buildDots();
    updateGalleryDisplay();
  }
});




// Initialize all event listeners
document.addEventListener('DOMContentLoaded', function() {
    // Initialize gallery display
    slidesPerView = getSlidesPerView();
    buildDots();
    updateGalleryDisplay();

    // Add smooth scrolling
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Initialize gallery auto-play (optional)
    // Uncomment to enable auto-rotating gallery every 5 seconds
    /*
    setInterval(() => {
        nextGallery();
    }, 5000);
    */
});


// Track page analytics (optional - replace with your analytics code)
function trackEvent(eventName, eventData) {
    if (window.gtag) {
        gtag('event', eventName, eventData);
    }
    console.log('Event tracked:', eventName, eventData);
}


// Accessibility: Ensure all interactive elements are keyboard accessible
document.addEventListener('keydown', function(event) {
    // Tab key navigation
    if (event.key === 'Tab') {
        const focusedElement = document.activeElement;
        console.log('Focused element:', focusedElement);
    }
});

// Mobile menu toggle (if needed)
function toggleMobileMenu() {
    const menu = document.querySelector('.mobile-menu');
    if (menu) {
        menu.classList.toggle('active');
    }
}

// Scroll to top function
function scrollToTop() {
    window.scrollTo({
        top: 200,
        behavior: 'smooth'
    });
}

// Add scroll event listener for animations
let ticking = false;
window.addEventListener('scroll', function() {
    if (!ticking) {
        window.requestAnimationFrame(function() {
            // Add any scroll-based animations here
            const elements = document.querySelectorAll('.process-step, .gallery-item');
            elements.forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                }
            });
            ticking = false;
        });
        ticking = true;
    }
});
